import { Can, abilitiesPlugin } from '@casl/vue'
import { buildAbility } from '../config/ability'
import type { App } from 'vue'

export const ability = buildAbility()

export const useCasl = (app: App) => {
  app.use(abilitiesPlugin, ability, { useGlobalProperties: true })
  app.component(Can.name, Can)

  app.provide('$ability', app.config.globalProperties.$ability)
}
